// extracted by mini-css-extract-plugin
export var copyable = "_f-1";
export var explainable = "_f-0";
export var negative = "_f-2";
export var positive = "_f-3";